export const ILLUSTRATIONS = Array.from({ length: 50 }, (_, i) => {
  const index = i + 1;
  return {
    imageUrl: `https://caelor-apps.web.app/images/illustrations/illustration-${index}.svg`,
    source: "csf",
    link: `https://caelor-apps.web.app/images/illustrations/illustration-${index}.svg`,
    id: crypto.randomUUID(),
  };
});
